import React from 'react'
// import { Modal, ModalHeader } from 'reactstrap';
import { DeleteAgreement } from './DeleteAgreement';
import { FormSelectSecctions } from './FormSelectSecctions';
import { UpdateStatusAgreemet } from './UpdateStatusAgreemet';
import { Dialog } from 'primereact/dialog';


export const ModalAgreement = (props) => {

    const {
        modal, modalTitle, toggle, method, loading,
        name_company, contract_number, validity, status,
        saveDelete,
        sections, selectSecctionsInput, listExamProfile,
        saveSelectExamProfile, handleSelect, handleSelectAll, saveUpdateStatus,
        confirmationDelete, isDelete, valueCode, setValueCode
    } = props;
    //method !== 'delete'

    return (
        <Dialog
            header={modalTitle}
            visible={modal}
            className={(method === "updateStatus" || method === "listSelectSections") ? "small-dialog" : "medium-dialog"}
            modal
            closable={true}
            onHide={toggle}
            headerStyle={{
                backgroundColor: (method === 'delete' ? '#bd2130' : '#0d3b59'),
                color: 'white',
                fontWeight: 'bold'
            }}
        >

            {
                method === "listSelectSections"
                    ? <FormSelectSecctions
                        {
                        ...{
                            toggle, loading, sections, selectSecctionsInput, listExamProfile, saveSelectExamProfile, handleSelect, handleSelectAll
                        }
                        }
                    />
                    : (method === "updateStatus")

                        ? <UpdateStatusAgreemet button="Si, actualizar" {...{ toggle, loading, name_company, contract_number, status, validity, saveUpdateStatus, }} />

                        : <DeleteAgreement {...{ toggle, loading, name_company, contract_number, validity, saveDelete, confirmationDelete, isDelete, valueCode, setValueCode }} />
            }
        </Dialog>
    )
}
